import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LmoFracsService } from '~lmo/services';

const existingObservables: Record<number, Observable<string | null>> = {};

@Pipe({
  name: 'fracNameFromId$',
})
export class FracNameFromIdPipe implements PipeTransform {
  constructor(private fracService: LmoFracsService) {}

  // tslint:disable-next-line
  public transform(value: number): Observable<string> {
    if (!existingObservables[value]) {
      existingObservables[value] = this.fracService.fracSummaries$.pipe(
        map((sums) => {
          return (sums || []).find((s) => s.lmoFracSummary.id === value);
        }),
        map((s) => (s ? s.lmoFracSummary.name : null)),
      );
    }
    return existingObservables[value];
  }
}
